import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { API_URL } from '../config';
import { getValidImageUrl } from '../utils/getImageUrl';



const ProductCard = ({ product }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="glass-card ea-card rounded-xl overflow-hidden transition-all flex flex-col"
    >
      <div className="relative aspect-square w-full bg-surface-container-low">
        {/* Skeleton Loader */}
        {!imageLoaded && (
          <div className="absolute inset-0 flex items-center justify-center animate-pulse">
            <span className="material-symbols-outlined text-white/10 text-5xl">image</span>
          </div>
        )}
        
        <img 
          alt={`${product.name || 'EA'} Logo`} 
          className={`w-full h-full object-cover group-hover:scale-105 transition-all duration-700 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`} 
          src={product.image ? getValidImageUrl(product.image) : `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400"><rect width="400" height="400" fill="%231a1e23"/><rect width="360" height="360" x="20" y="20" fill="%231a1e23" stroke="%23f0b90b" stroke-width="2" stroke-opacity="0.2" rx="20"/><path d="M200 160 l40 60 h-80 z" fill="%23f0b90b" opacity="0.5"/><circle cx="240" cy="140" r="15" fill="%23f0b90b" opacity="0.5"/><text x="50%" y="260" font-family="sans-serif" font-size="16" fill="%23f0b90b" opacity="0.5" dominant-baseline="middle" text-anchor="middle">NO IMAGE PROVIDED</text></svg>`}
          onLoad={() => setImageLoaded(true)}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400"><rect width="400" height="400" fill="%231a1e23"/><rect width="360" height="360" x="20" y="20" fill="%231a1e23" stroke="%23f0b90b" stroke-width="2" stroke-opacity="0.2" rx="20"/><path d="M200 160 l40 60 h-80 z" fill="%23f0b90b" opacity="0.5"/><circle cx="240" cy="140" r="15" fill="%23f0b90b" opacity="0.5"/><text x="50%" y="260" font-family="sans-serif" font-size="16" fill="%23f0b90b" opacity="0.5" dominant-baseline="middle" text-anchor="middle">IMAGE UNAVAILABLE</text></svg>`;
            setImageLoaded(true);
          }}
        />
        {product.id === 'quantum-athena' && (
          <div className="absolute top-4 left-4 bg-primary text-on-primary px-2 py-0.5 rounded text-[10px] font-bold uppercase">Trending</div>
        )}
      </div>
      <div className="p-5 flex-grow">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-bold text-silver-text">{product.name}</h3>
          <span className="text-[10px] bg-white/5 px-2 py-0.5 rounded border border-white/10">MT4/MT5 EA</span>
        </div>
        <div className="flex items-center space-x-1 mb-4">
          <span className="text-primary text-[12px]">★</span>
          <span className="text-[12px] font-bold text-silver-text">4.9</span>
          <span className="text-[10px] text-on-surface-variant">(122 reviews)</span>
        </div>
        <div className="grid grid-cols-3 gap-2 mb-6">
          <div className="bg-surface-container p-2 rounded text-center">
            <div className="text-[10px] text-on-surface-variant uppercase mb-1">Win Rate</div>
            <div className="text-secondary font-bold text-[12px]">{product.winRate || "78.15%"}</div>
          </div>
          <div className="bg-surface-container p-2 rounded text-center">
            <div className="text-[10px] text-on-surface-variant uppercase mb-1">Drawdown</div>
            <div className="text-error font-bold text-[12px]">{product.maxDrawdown || "6.05%"}</div>
          </div>
          <div className="bg-surface-container p-2 rounded text-center">
            <div className="text-[10px] text-on-surface-variant uppercase mb-1">Profit Factor</div>
            <div className="text-silver-text font-bold text-[12px]">4.12</div>
          </div>
        </div>
        <div className="flex items-center justify-between pt-4 border-t border-white/5">
          <div className="flex flex-col">
            <span className="text-[10px] text-on-surface-variant line-through">${product.oldPrice || "499"}</span>
            <span className="text-headline-sm font-bold text-primary">${product.newPrice || "79"}</span>
          </div>
          <Link to={`/ea/${product.id}`} className="bg-primary/10 text-primary hover:bg-primary hover:text-on-primary px-4 py-2 rounded text-[12px] font-bold transition-all btn-shimmer inline-block">
            View Details
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;
